import React, { useEffect, useState } from 'react';
import { apiService } from '../services/apiService';
import TaskSubNav from '../components/TaskSubNav';
import { DSPageHeader, DSInput, DSStatTile, DSIcon, DSBadge } from '../design-system/primitives';
import StatusBadge from '../components/StatusBadge';
import './taskManagementShared.css';

function TaskReporting() {
  const [completionLog, setCompletionLog] = useState([]);
  const [summary, setSummary] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadData = async () => {
    try {
      setLoading(true);
      const params = {};
      if (startDate) {
        params.startDate = startDate;
      }
      if (endDate) {
        params.endDate = endDate;
      }
      const response = await apiService.getTaskReporting(params);
      setCompletionLog(response.data?.completionLog || []);
      setSummary(response.data?.summary || null);
    } catch (err) {
      setError(err.response?.data?.error || 'Unable to load reporting data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const formatCurrency = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(value || 0));

  return (
    <div className="tm-page">
      <DSPageHeader title="History & Reports" />

      <div className="tm-filters">
        <div className="tm-form-group">
          <DSInput label="Start Date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </div>
        <div className="tm-form-group">
          <DSInput label="End Date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      {summary && (
        <div className="tm-stat-row">
          <DSStatTile value={summary.completions} label="Completions" />
          <DSStatTile value={summary.points_awarded} label="Points Awarded" />
          <DSStatTile value={formatCurrency(summary.bounties_paid)} label="Bounties Paid" />
        </div>
      )}

      {loading ? (
        <div className="loading-inline">Loading...</div>
      ) : completionLog.length === 0 ? (
        <div className="tm-empty-state"><h2>No completions in this range</h2></div>
      ) : (
        <div className="tm-card-list">
          {completionLog.map((row) => (
            <div key={row.id} className="tm-needs-attention-row">
              <div>
                <strong>{row.task_title}</strong>
                <div className="tm-suggestion-meta">{row.user_name} · {new Date(row.completed_at).toLocaleDateString()}</div>
              </div>
              <div className="tm-task-tags">
                <DSBadge variant="brand" size="sm" leadingIcon={<DSIcon name="star" />}>{row.points_awarded}</DSBadge>
                {row.bounty_share_amount && <StatusBadge variant="warning" size="sm">{formatCurrency(row.bounty_share_amount)}</StatusBadge>}
              </div>
            </div>
          ))}
        </div>
      )}
      <TaskSubNav />
    </div>
  );
}

export default TaskReporting;
